import React from 'react';
import './Resources.css';

export const Resources: React.FC<{}> = () => {
  return <p className="resources">Nothing here</p>;
};
